import { useRef, useEffect, useState, JSX } from "react";

import styles from "./styles.module.scss";

interface IBlockWithExtraContent {
  blockName: string;
  heightInPx: number;
  widthInPx: number;
  itemsContent: () => JSX.Element;
}

export const BlockWithExtraContent = ({
  blockName,
  heightInPx,
  widthInPx,
  itemsContent,
}: IBlockWithExtraContent) => {
  const [contentBlockHeight, setContentBlockHeight] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const availableHeight = heightInPx - 80;

  const isRenderButton = contentBlockHeight > availableHeight;

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const updateHeight = () => {
      if (contentRef.current) {
        const height = contentRef.current.scrollHeight;
        setContentBlockHeight(height);
      }
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(updateHeight);
    if (contentRef.current) {
      resizeObserver.observe(contentRef.current);
    }

    const handleWindowResize = () => {
      updateHeight();
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <div
      style={{ height: `${heightInPx}px`, maxWidth: `${widthInPx}px` }}
      className={styles.blockWithExtraContent}
    >
      <div className={styles.blockTitle}>{blockName}</div>
      <div
        ref={contentRef}
        className={styles.contentWrapper}
        style={{
          maxHeight: `${availableHeight}px`,
          overflowY: "hidden",
        }}
      >
        {itemsContent()}
      </div>
      {isRenderButton && (
        <div className={styles.buttonWrapper}>
          <button onClick={openModal} className={styles.toggleButton}>
            Показать полностью
          </button>
        </div>
      )}
      {showModal && (
        <div className={styles.modalOverlay} onClick={closeModal}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.modalHeader}>
              <h2>{blockName}</h2>
              <button className={styles.closeButton} onClick={closeModal}>
                ×
              </button>
            </div>
            <div className={styles.modalBody}>{itemsContent()}</div>
          </div>
        </div>
      )}
    </div>
  );
};
